export const createProductArray = (substepProducts, dataProducts) => {
    const newArray = []
    for (let j = 0; j < substepProducts.length; j++) {
        newArray.push(dataProducts[substepProducts[j]])
    }
    return newArray.sort((a, b) => a.productName.localeCompare(b.productName))
}